module.exports = __webpack_public_path__ + "static/media/kiki.97fb3005.jpeg";